import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import './sociogram.css';
import EntryData from '../../services/entry-service';
import SocioData from '../../services/socio-service';
import PeopleData from '../../services/people-service';
import { useParams } from 'react-router-dom';
import { DownloadTableExcel } from 'react-export-table-to-excel';


export class Square extends React.Component {
    render() {
      let bgColor = "white";
      let content = "";
      if( this.props.selections ){
        for (var i = 0; i < this.props.selections.length; i++ ){
          if( this.props.selections[i] === this.props.id ){
            if( this.props.match )
              bgColor = "green";
            else
              bgColor = "red";
          }
        }
      }
      if( this.props.favourite ){
        content = '\u2605';
      }
      // don't set a background colour if no selection is found (red/green)
      if( bgColor == "white" )
        return (<td></td>);

      return (
      <td style={{backgroundColor: bgColor}}>
          <div style={{color: "yellow", fontSize: 20}}>{content}</div>
      </td>
      );
    }

    filterUsers(user,data){
      return data.filter(
        function(data){ return data.personID == user }
      );
    }
}

export const Board = ({ data, accessToken, sociogramId }) => {

  const renderSquare = (i) => {
    return <Square />;
  };

  const socioTableRef = useRef(null);
  const [isTableReady, setIsTableReady] = useState(false);

   // Set up state with useState hook
   const [analysis, setAnalysis] = useState("");
   const [loader, setLoader] = useState(false);

  const analyse = async () => {
    setLoader(true);
    setAnalysis(await SocioData.analyse(sociogramId,accessToken));
    setLoader(false);
  };
  
  // Use useEffect to ensure the table ref is established after render
  useEffect(() => {
    if (socioTableRef.current) {
      setIsTableReady(true);
    }
  }, []);
  
  let rows = [];
  let namesRow = [];
  let popularityRow = [];
  
  // first cell is empty
  namesRow.push(<td key="empty-header"></td>);
  popularityRow.push(<td key="popularity-header"><b>Popularity</b></td>);
  
  for (let i = 0; i < data.length; i++) {
    namesRow.push(
      <td key={`name-${i}`} className="rotateText">
        {data[i].personName}
      </td>
    );
  }
  
  namesRow.push(<td key="mutual-count-header">Mutual Count</td>);
  rows.push(<tr key="names-row">{namesRow}</tr>);
  
  let mutualCount = 0;
  let popularityCount = {};
  
  for (let i = 0; i < data.length; i++) {
    if (data[i]["selection"]) {
      for (let selectedUsersCount = 0; selectedUsersCount < data[i].selection.length; selectedUsersCount++) {
        if (!popularityCount[data[i].selection[selectedUsersCount]]) {
          popularityCount[data[i].selection[selectedUsersCount]] = 1;
        } else {
          popularityCount[data[i].selection[selectedUsersCount]] = popularityCount[data[i].selection[selectedUsersCount]] + 1;
        }
      }
    }
    
    let squares = [];  
    for (let x = 0; x < data.length; x++) {
      let match = false;
      let favourite = false;
      
      // if data[i] (vertical user) favourite matches horizontal user( data[x]), mark as favourite
      if (data[i].favourite === data[x].personID) {
        favourite = true;
      }
      
      if (data[i]["selection"]) {
        for (let y = 0; y < data[i].selection.length; y++) {
          if (data[x]["selection"]) {
            for (let z = 0; z < data[x].selection.length; z++) {
              if (data[i].selection[y] === data[x].personID && data[x].selection[z] === data[i].personID) {
                mutualCount++;
                match = true;
              }
            }
          }
        }
      }
      
      squares.push(
        <Square 
          key={`square-${i}-${x}`}
          id={data[x].personID} 
          id2={data[i].personID} 
          selections={data[i].selection} 
          parentSelections={data[x].selection} 
          match={match} 
          favourite={favourite} 
        />
      );
    }
    
    squares.push(<td key={`mutual-count-${i}`}>{mutualCount}</td>);
    
    // vertical column for names follows by socio values
    rows.push(
      <tr key={`row-${i}`} className="board-row">
        <td>
          {data[i].personName}
        </td>
        {squares}
      </tr>
    );
    
    mutualCount = 0;
  }
  
  for (let i = 0; i < data.length; i++) {
    popularityRow.push(
      <td key={`popularity-${i}`}>
        {popularityCount[data[i].personID]}
      </td>
    );
  }
  
  rows.push(<tr key="popularity-row">{popularityRow}</tr>);
  console.log(rows);

  return (
    <div>
      {isTableReady && (
        <DownloadTableExcel
          filename="users table"
          sheet="users"
          currentTableRef={socioTableRef.current} >
          <button>Export Sociogram to Excel File</button>
        </DownloadTableExcel>
        
      )}
      <button
        type="button"
        onClick={analyse}>
        Analyse Sociogram with AI
        </button>
      {loader && (
        <svg width="150" height="30" viewBox="0 0 150 30" xmlns="http://www.w3.org/2000/svg" fill="#333">
          <circle cx="100" cy="15" r="3">
            <animate attributeName="r" values="3;6;3" dur="1s" repeatCount="indefinite" begin="0s"/>
          </circle>
          <circle cx="115" cy="15" r="3">
            <animate attributeName="r" values="3;6;3" dur="1s" repeatCount="indefinite" begin="0.2s"/>
          </circle>
          <circle cx="130" cy="15" r="3">
            <animate attributeName="r" values="3;6;3" dur="1s" repeatCount="indefinite" begin="0.4s"/>
          </circle>
        </svg>
      )}
      <p><pre>{analysis}</pre></p>
      <table ref={socioTableRef}>
        <tbody>
          {rows}
        </tbody>
      </table>
    </div>
  );
};

export const SociogramRender = ({ accessToken }) => {
  // Use the useParams hook to get the id parameter from the URL
  const { id } = useParams();
  
  // Set up state with useState hook
  const [state, setState] = useState({
    entries: [],
    sociogram: null,
    people: [],
    data: null,
    accessToken,
    id
  });

  // Replace componentDidMount with useEffect
  useEffect(() => {
    // Create an async function inside useEffect
    const fetchData = async () => {
      try {
        // Get entries
        const entries = await EntryData.getEntriesBySociogram(id, accessToken);
        setState(prevState => ({
          ...prevState,
          entries
        }));

        // Get sociogram data
        const sociogramData = await SocioData.getSociogram(id, accessToken);
        
        // Update sociogram in state
        setState(prevState => ({
          ...prevState,
          sociogram: sociogramData
        }));

        // Get people data
        const peopleData = await PeopleData.queryData(sociogramData.people, accessToken);
        sociogramData.people = peopleData;

        // Update sociogram in state
        setState(prevState => ({
          ...prevState,
          sociogram: sociogramData
        }));
        
        // Generate sociogram JSON
        const mainData = produceSociogramJSON(peopleData, entries);
        
        // Update state with people and data
        setState(prevState => ({
          ...prevState,
          people: peopleData,
          data: mainData
        }));
      } catch (error) {
        console.error("Error loading sociogram data:", error);
      }
    };

    if (id && accessToken) {
      fetchData();
    }
    
    // Dependencies array - re-run when id or accessToken changes
  }, []);

  // Convert static methods to regular functions
  const produceSociogramJSON = (people, entries) => {
    const sociogramBody = [];
    
    for (let personCount = 0; personCount < people.length; personCount++) {
      const person = people[personCount];
      const item = {
        personID: person.id,
        personName: person.givenName + " " + person.surname,
        selection: findEntrySelectionsByPersonID(person.id, entries),
        favourite: findEntryFavouriteByPersonID(person.id, entries)
      };
      
      sociogramBody.push(item);
    }

    console.log(JSON.stringify(sociogramBody, null, 4));
    
    return sociogramBody;
  };

  const findEntrySelectionsByPersonID = (personID, entries) => {
    for (let i = 0; i < entries.length; i++) {
      if (entries[i].person === personID) {
        return entries[i].socioData;
      }
    }
    return null;
  };

  const findEntryFavouriteByPersonID = (personID, entries) => {
    for (let i = 0; i < entries.length; i++) {
      if (entries[i].person === personID) {
        return entries[i].socioFavourite;
      }
    }
    return null;
  };

  // Render the component
  return (
    <div>
      <div className="game">
        {state.data && <Board data={state.data} accessToken={state.accessToken} sociogramId={state.id} />}
      </div>
    </div>
  );
};

// Move static methods outside to make them available to the component
// These could also be moved to a utility file if needed
export const produceSociogramJSON = (people, entries) => {
  const sociogramBody = [];
  
  for (let personCount = 0; personCount < people.length; personCount++) {
    const person = people[personCount];
    const item = {
      personID: person.id,
      personName: person.givenName + " " + person.surname,
      selection: findEntrySelectionsByPersonID(person.id, entries),
      favourite: findEntryFavouriteByPersonID(person.id, entries)
    };
    
    sociogramBody.push(item);
  }
  
  return sociogramBody;
};

export const findEntrySelectionsByPersonID = (personID, entries) => {
  if (!entries) return null;
  
  for (let i = 0; i < entries.length; i++) {
    if (entries[i].person === personID) {
      return entries[i].socioData;
    }
  }
  return null;
};

export const findEntryFavouriteByPersonID = (personID, entries) => {
  if (!entries) return null;
  
  for (let i = 0; i < entries.length; i++) {
    if (entries[i].person === personID) {
      return entries[i].socioFavourite;
    }
  }
  return null;
};

//export default SociogramRender;


